const AccessIssueApi = (workId: string) => {
  return {
    BY_WORK_ID: `/driver/work/${workId}/issue`,
  };
};
export default AccessIssueApi;
